<template>
  <b-sidebar
    id="mobile-menu-sidebar"
    title="RUSH Estore"
    width="100%"
    no-header
    class="d-auto d-lg-none"
    :style="mobileSidebarStyles"
  >
    <div class="px-3 py-2 h-100 d-flex flex-column justify-content-between">
      <b-navbar-nav>
        <template v-if="loggedIn">
          <span
            class="profile-menu-link"
            id="profileDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <template
              v-if="
                customer.constructor === Object && 
                Object.keys(customer).length
              "
            >
              <template
                v-if="
                  !customer.profile_image ||
                  customer.profile_image.includes('default')
                "
              >
                <profile-icon />
                {{ `${customer.firstname} ${customer.lastname}` }}
              </template>
              <template v-else>
                <img
                  :src="customer.profile_image"
                  alt="Profile"
                  class="ml-2 mr-2 profile-image rounded-circle"
                />
                {{ `${customer.firstname} ${customer.lastname}` }}
              </template>
            </template>
            <template v-else>
              <template
                v-if="
                  !user.customer.profile_image ||
                  user.customer.profile_image.includes('default')
                "
              >
                <profile-icon />
                {{ `${user.customer.firstname} ${user.customer.lastname}` }}
              </template>
              <template v-else>
                <img
                  :src="user.customer.profile_image"
                  alt="Profile"
                  class="ml-2 mr-2 profile-image rounded-circle"
                />
                {{ `${user.customer.firstname} ${user.customer.lastname}` }}
              </template>
            </template>
            <img
              src="@/assets/images/arrow-down.svg"
              class="profile-collapse"
              v-b-toggle.collapse-user
              ref="userProfileToggle"
              alt="Down Arrow"
            />
          </span>
          <b-collapse id="collapse-user" class="mt-2" v-model="isUserCollapsed">
            <b-card class="border-0 bg-transparent" body-class="px-2">
              <div class="d-flex align-items-center mb-3 cursor-pointer" @click="changeRoute('my-profile')">
                <div
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  v-if="webDesign !== null && webDesign.design !== null"
                  :style="{
                    backgroundColor:
                      webDesign.design.main_color + '!important'
                  }"
                  style="width: 35px; height: 35px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/person.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <div
                  v-else
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  style="background-color: #ff8a00; width: 45px; height: 45px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/person.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <span :style="{ color: routeActive('my-profile') ? mainColor : '#2f3941' }">My Profile</span>
              </div>
              <div class="d-flex align-items-center mb-3 cursor-pointer" v-if="isEstoreTopUp" @click="changeRoute('orders')">
                <div
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  v-if="webDesign !== null && webDesign.design !== null"
                  :style="{
                    backgroundColor:
                      webDesign.design.main_color + '!important'
                  }"
                  style="width: 35px; height: 35px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/shopping-bag.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <div
                  v-else
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  style="background-color: #ff8a00; width: 45px; height: 45px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/shopping-bag.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <span :style="{ color: (routeActive('upcoming') || routeActive('past')) ? mainColor : '#2f3941' }">My Orders</span>
              </div>
              <div class="d-flex align-items-center mb-3 cursor-pointer" v-if="isEstoreTopUp" @click="changeRoute('transaction-history')">
                <div
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  v-if="webDesign !== null && webDesign.design !== null"
                  :style="{
                    backgroundColor:
                      webDesign.design.main_color + '!important'
                  }"
                  style="width: 35px; height: 35px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/ic-transaction-history.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <div
                  v-else
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  style="background-color: #ff8a00; width: 45px; height: 45px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/ic-transaction-history.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <span :style="{ color: (routeActive('upcoming') || routeActive('past')) ? mainColor : '#2f3941' }">Transaction History</span>
              </div>
              <div v-if="subdomain === 'ucoin'" class="d-flex align-items-center mb-3 cursor-pointer" @click="changeRoute('my-points')">
                <div
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  v-if="webDesign !== null && webDesign.design !== null"
                  :style="{
                    backgroundColor:
                      webDesign.design.main_color + '!important'
                  }"
                  style="width: 35px; height: 35px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/ic-star-outline.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <div
                  v-else
                  class="mr-10 d-flex align-items-center justify-content-center mr-7"
                  style="background-color: #ff8a00; width: 45px; height: 45px; border-radius: 50%;"
                >
                  <img
                    src="@/assets/images/ic-star-outline.svg"
                    width="20px"
                    height="18px"
                    alt
                  />
                </div>
                <span :style="{ color: routeActive('my-profile') ? mainColor : '#2f3941' }">My Points</span>
              </div>
              <div class="mt-3 cursor-pointer" style="color: #2f3941;" @click="logout()">Sign Out</div>
            </b-card>
          </b-collapse>
        </template>
        <div :class="['points-container mb-2 d-flex align-items-center pl-2 pr-3', { 'mt-3': !isUserCollapsed }]" v-if="isPointsView && loggedIn">
          <div class="star-container">
            <img src="@/assets/images/points-badge.svg" alt="points" />
          </div>
          <div class="balance-container">
            <span class="mr-2"><strong class="fw-bold">{{ putComma(balance) }}</strong></span>
            <span v-if="balance <= 1">{{
              subdomain === "ucoin" ? "UCOIN" : "Pt."
            }}</span>
            <span v-else style="color: lightgrey">{{
              subdomain === "ucoin" ? "UCOINS" : "Pts."
            }}</span>
          </div>
        </div>
        <b-nav-text>
          <div class="cursor-pointer" @click="changeRoute('')">
            <span :style="{ color: (routeActive('') || routeActive('estore')) ? mainColor : '#2f3941' }">Home</span>
          </div>
        </b-nav-text>
        <template v-if="!loggedIn">
          <b-nav-text>
            <div class="cursor-pointer" @click="changeRoute('login')">
              <span :style="{ color: routeActive('login') ? mainColor : '#2f3941' }">Sign In</span>
            </div>
          </b-nav-text>
          <b-nav-text>
            <div class="cursor-pointer" @click="changeRoute('signup')">
              <span :style="{ color: routeActive('signup') ? mainColor : '#2f3941' }">Create Account</span>
            </div>
          </b-nav-text>
        </template>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-text>
          <div class="cursor-pointer" @click="changeRoute('terms-of-use')">
            <span :style="{ color: routeActive('terms-of-use') ? mainColor : '#2f3941' }">Terms of Use</span>
          </div>
        </b-nav-text>
        <b-nav-text>
          <div class="cursor-pointer" @click="changeRoute('privacy-policy')">
            <span :style="{ color: routeActive('privacy-policy') ? mainColor : '#2f3941' }">Privacy Policy</span>
          </div>
        </b-nav-text>
        <b-nav-text class="mt-3 bottom-brand">
          <a href="https://www.rush.ph/" target="_blank" rel="noopener">Powered by <strong>RUSH</strong></a>
        </b-nav-text>
      </b-navbar-nav>
    </div>
  </b-sidebar>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ProfileIcon from "@/components/customer/ProfileIcon.vue";

export default {
  components: { ProfileIcon },
  data () {
    return {
      isUserCollapsed: false,
      mobileSidebarStyles: {}
    }
  },
  computed: {
    ...mapGetters({
      isEstoreTopUp: "merchant/isEstoreTopUp",
      loggedIn: "auth/loggedIn",
      isPointsView: "merchant/isPointsView"
    }),
    ...mapState("merchant", {
      subdomain: state => state.subdomain
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
    ...mapState("customer", {
      customer: state => state.user
    }),
    ...mapState("auth", {
      user: state => state.user
    }),
    ...mapState("point", {
      balance: state => state.balance
    }),
    mainColor () {
      return this.webDesign !== null && this.webDesign.design !== null
        ? this.webDesign.design.main_color
        : '#ff8a00'
    }
  },
  mounted () {
    window.addEventListener('load', () => {
      if (!document.getElementById('navbar-top-container')) return;

      const navbarTopContainerHeight = document.getElementById('navbar-top-container').clientHeight;
      this.$nextTick(() => {
        this.calculateMobileSideBar(navbarTopContainerHeight);
      });
    });
    window.addEventListener('resize', () => {
      if (!document.getElementById('navbar-top-container')) return;

      const navbarTopContainerHeight = document.getElementById('navbar-top-container').clientHeight;
      this.$nextTick(() => {
        this.calculateMobileSideBar(navbarTopContainerHeight);
      });
    });
  },
  methods: {
    routeActive (route) {
      return this.$route.path.split('/').pop() === route
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        if (this.$route.name != "Home") {
          this.$router.push({ path: "/" + this.subdomain });
        }
      });
    },
    changeRoute (route) {
      this.$root.$emit('toggleMobileNavIcon', route);
      this.$nextTick(() => {
        const path = this.$route.path.split('/').pop();
        const isSamePage = path !== route
          ? (route === 'orders' && path === 'upcoming') || (route === '' && path === 'estore')
          : path === route;
        if (!isSamePage) {
          if (route === 'terms-of-use' || route === 'privacy-policy') {
            window.open(`/${this.subdomain}/${route}`)
          } else {
            this.$router.push({ path: `/${this.subdomain}/${route}` })
          }
        }
        if (this.isUserCollapsed) {
          this.$refs.userProfileToggle.click();
        }
      });
    },
    putComma(number) {
      return number !== null
        ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : '';
    },
    calculateMobileSideBar(navbarTopContainerHeight) {
      this.mobileSidebarStyles = {
        '--height': `calc(100vh - ${navbarTopContainerHeight - 15}px)`,
        '--top': `${navbarTopContainerHeight - 10}px`
      };
    }
  }
}
</script>

<style lang="scss">
#mobile-menu-sidebar {
  height: var(--height) !important;
  top: var(--top) !important;
  bottom: 0;
  overflow-y: auto;
  .rounded-50 {
    border-radius: 50px;
    cursor: pointer;
  }
  .bottom-brand {
    font-size: 13px;
    color: #ff8a00;
    b {
      @extend .mainFontBold;
    }
    a {
      text-decoration: none;
    }
  }
  .profile-image {
    width: 60px;
    height: 60px;
  }
  .profile-collapse {
    outline: 0;
    transition: all ease 0.2s;
    &.not-collapsed {
      transform: rotate(180deg);
    }
  }
  .points-container {
    height: 40px;
    border: 1px solid #d8dcde;
    border-radius: 38px;
    display: flex;
    width: fit-content;
    .balance-container {
      color: #87929D;
      flex: 1;
      padding: 5px 20px 5px 10px;
      .fw-bold {
        color: #2F3941;
      }
    }
    a:hover {
      text-decoration: none !important;
    }
  }
}
</style>
